export const isDecPageField = (obj) => {
    return !!(obj &&
        typeof obj === 'object' &&
        !Array.isArray(obj) &&
        obj.hasOwnProperty('confidence_score') &&
        obj.hasOwnProperty('coordinates') &&
        obj.hasOwnProperty('page_number') &&
        obj.hasOwnProperty('value'));
};
